import { render } from "./DetalleHomeComponent.vue?vue&type=template&id=a83b0318"
import script from "./DetalleHomeComponent.vue?vue&type=script&lang=js"
export * from "./DetalleHomeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__